import { Fragment } from '../types';

/**
 * Picks a signed read URL from `fragment.assets` for playback or export.
 * Video fragments prefer `video` then `audio`; other types prefer `audio` then `video`.
 */
export function getFragmentMediaUrl(fragment: Fragment): string | undefined {
  const audioUrl = fragment.assets.audio?.url;
  const videoUrl = fragment.assets.video?.url;
  if (fragment.mediaType === 'VIDEO') {
    return videoUrl ?? audioUrl;
  }
  return audioUrl ?? videoUrl;
}
